module.exports = __webpack_public_path__ + "static/media/home.68df27bd.png";